import { Text } from '@change/ds-core-ui';

import type { PageHeaderTitleProps } from '../../types';

export const PageHeaderTitle: React.FC<PageHeaderTitleProps> = ({ image, title }: PageHeaderTitleProps) => {
	return (
		<div
			data-testid="page-header-title"
			className="md:auto flex h-[48px] w-full flex-shrink-0 grow basis-0 flex-row items-center gap-[var(--space-3,12px)] md:gap-[var(--space-3-5,14px)]"
		>
			{image}
			<Text
				data-testid="page-header-text"
				as="h1"
				truncate
				className="color-[var(--typography-strong-color,#403A49)] !line-clamp-2 flex-1 flex-shrink-0 grow basis-0 !whitespace-break-spaces text-size-heading-xxs"
			>
				{title}
			</Text>
		</div>
	);
};
